export enum PromoCodeRewardTypeEnum {
  WALLET = 'wallet',
  WALLET_PERCENT = 'wallet-percent',
  ITEM = 'item',
  FREE_CASE = 'free-case',
  PROMOCODE = 'promocode',
}
